import AppIcon from '../AppIcon';
import './style.css';

const AppEmptyImage = ({ className, width, height, iconWidth = 80 }: { className?: string; width?: number; height?: number; iconWidth?: number }) => {
  return (
    <div
      className={`app-empty-image ${className || ''}`}
      style={{
        width: width || undefined,
        height: height || undefined,
      }}
    >
      <AppIcon icon="solar:camera-bold" width={iconWidth} className="app-empty-image-icon" />
      <p className="app-empty-image-text">Sem Foto</p>
    </div>
  );
};

export default AppEmptyImage;
